"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { WhaleWatchPersistedFilters } from "@/app/(app)/whale-watch/whale-watch-filters";

interface AppShellInitialState {
  whaleWatchFilters?: WhaleWatchPersistedFilters | null;
}

const EMPTY_APP_SHELL_INITIAL_STATE: AppShellInitialState = {};

const AppShellInitialStateContext = createContext<AppShellInitialState>(
  EMPTY_APP_SHELL_INITIAL_STATE,
);

export function AppShellInitialStateProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: AppShellInitialState;
}) {
  return (
    <AppShellInitialStateContext.Provider value={value}>
      {children}
    </AppShellInitialStateContext.Provider>
  );
}

export function useAppShellInitialState() {
  return useContext(AppShellInitialStateContext);
}
